{
  "currency": "JOD",
  "side": {
    "OWES": "عليه",
    "OWED": "له"
  },
  "kinds": {
    "DEBIT": "مدين",
    "CREDIT": "دائن",
    "MIGRATED": "حركة مُرحَّلة",
    "MIGRATED_ADJUSTMENT": "تسوية مُرحَّلة"
  },
  "badges": {
    "migrated": "مُرحَّلة",
    "adjustment": "تسوية مُرحَّلة",
    "edited": "معدّلة",
    "editedBy": "تم التحديث بواسطة {{name}}، {{time}}"
  },
  "balanceStatus": {
    "label": "حالة الرصيد",
    "OWES": "عليه رصيد",
    "OWED": "له رصيد",
    "ZERO": "رصيد صفر"
  },
  "linkStatus": {
    "label": "ربط العملاء",
    "LINKED": "مرتبط",
    "PENDING": "بانتظار الربط",
    "INVALID_PHONE": "رقم غير صالح"
  },
  "messageStatus": {
    "label": "حالة الرسالة",
    "PENDING": "قيد الإرسال",
    "SENT": "تم الإرسال",
    "DELIVERED": "تم التسليم",
    "READ": "تمت القراءة",
    "FAILED": "فشل الإرسال",
    "INVALID_PHONE": "رقم غير صالح",
    "resend": "إعادة إرسال الرسالة"
  },
  "columns": {
    "number": "الرقم",
    "reference": "الرقم المرجعي",
    "occurredAt": "تاريخ المعاملة",
    "customer": "العميل",
    "name": "اسم العميل",
    "phone": "رقم الهاتف",
    "branch": "الفرع",
    "statement": "البيان",
    "debit": "مدين",
    "credit": "دائن",
    "balance": "الرصيد",
    "debtLimit": "سقف الدين",
    "linkStatus": "ربط العملاء",
    "employee": "الموظف",
    "notes": "ملاحظات",
    "messageStatus": "حالة الرسالة",
    "createdBy": "تم الإنشاء بواسطة",
    "createdAt": "تاريخ الإنشاء",
    "updatedBy": "تم التحديث بواسطة",
    "updatedAt": "تم التحديث في",
    "deletedAt": "تاريخ الحذف",
    "deletedBy": "حذف بواسطة",
    "lastMovementAt": "تاريخ آخر حركة",
    "kind": "نوع الحركة",
    "amount": "المبلغ",
    "actions": "إجراءات",
    "account": "الحساب",
    "accountName": "اسم الحساب",
    "accountCount": "عدد الحسابات"
  },
  "totals": {
    "debit": "مجموع المدين",
    "credit": "مجموع الدائن",
    "net": "الرصيد",
    "count": "عدد الحركات",
    "overall": "المجموع",
    "countOf": "({{value}})"
  },
  "filters": {
    "allBranches": "جميع الفروع",
    "branch": "الفرع",
    "kind": "نوع الحركة",
    "employee": "الموظف",
    "customer": "العميل",
    "customerSearch": "البحث بالاسم أو رقم الهاتف أو الرقم...",
    "account": "الحساب",
    "allAccounts": "كل الحسابات",
    "allKinds": "جميع الأنواع",
    "allCustomers": "جميع العملاء",
    "allEmployees": "جميع الموظفين",
    "allStatuses": "جميع الحالات"
  },
  "export": {
    "excel": "تصدير إلى Excel",
    "pdf": "تصدير PDF",
    "exporting": "تصدير..."
  },
  "overview": {
    "title": "لمحة عامة",
    "cards": {
      "debtors": "عدد عملاء الذمم",
      "totalDebit": "إجمالي المبلغ المدين",
      "totalCredit": "إجمالي المبلغ الدائن",
      "todayDebit": "إجمالي المبلغ المدين اليوم",
      "todayCredit": "إجمالي المبلغ الدائن اليوم",
      "periodDebit": "إجمالي المبلغ المدين خلال الفترة",
      "periodCredit": "إجمالي المبلغ الدائن خلال الفترة"
    },
    "latest": "آخر الحركات"
  },
  "accounts": {
    "title": "عملاء الذمم",
    "add": "إضافة عميل",
    "editCustomer": "تعديل العميل",
    "addAccount": "إضافة حساب",
    "statement": "كشف العميل",
    "searchLabel": "البحث بالاسم أو رقم الهاتف أو الرقم",
    "searchPlaceholder": "البحث بالاسم أو رقم الهاتف أو الرقم...",
    "rowActionsTrigger": "إجراءات {{name}}",
    "fields": {
      "name": "اسم العميل",
      "phone": "رقم الهاتف",
      "countryCode": "رمز الدولة",
      "branch": "الفرع",
      "debtLimit": "سقف الدين",
      "accountName": "اسم الحساب"
    },
    "drawer": {
      "createDescription": "أدخل بيانات العميل الجديد.",
      "editDescription": "عدل بيانات العميل. لا يمكن تعديل الرصيد من هنا.",
      "branchPlaceholder": "اختر فرع...",
      "addAccountForCustomer": "إضافة حساب لهذا العميل",
      "viewCustomer": "عرض العميل"
    },
    "toasts": {
      "created": "تم إنشاء العميل بنجاح",
      "updated": "تم تحديث العميل بنجاح"
    }
  },
  "account": {
    "add": "إضافة حساب",
    "edit": "تعديل الحساب",
    "statement": "كشف الحساب",
    "rowActionsTrigger": "إجراءات الحساب {{name}}",
    "drawer": {
      "createDescription": "أدخل بيانات الحساب الجديد للعميل {{name}}.",
      "editDescription": "عدل بيانات الحساب. لا يمكن تعديل الرصيد من هنا.",
      "accountPlaceholder": "اختر حساب..."
    },
    "toasts": {
      "created": "تم إنشاء الحساب بنجاح",
      "updated": "تم تحديث الحساب بنجاح",
      "deleted": "تم حذف الحساب بنجاح"
    },
    "deleteDialog": {
      "title": "حذف الحساب؟",
      "description": "سيتم نقل الحساب {{account}} رقم {{number}} للعميل {{customer}} مع حركاته إلى سلة المحذوفات."
    }
  },
  "customer": {
    "totalBalance": "الرصيد الإجمالي",
    "tabs": {
      "accounts": "الحسابات",
      "statement": "كشف العميل"
    },
    "accountBalances": "أرصدة الحسابات"
  },
  "statement": {
    "title": "كشف الحساب",
    "back": "العودة إلى عملاء الذمم",
    "currentBalance": "الرصيد الحالي",
    "addMovement": "إضافة حركة",
    "previousBalance": "الرصيد السابق",
    "rowActionsTrigger": "إجراءات الحركة {{number}}",
    "details": "عرض التفاصيل",
    "deleteDialog": {
      "title": "تأكيد الحذف",
      "description": "هل أنت متأكد من حذف الحركة رقم {{number}}؟ سيعاد احتساب رصيد الحركات اللاحقة."
    },
    "toasts": {
      "deleted": "تم حذف الحركة بنجاح"
    }
  },
  "movement": {
    "createTitle": "إضافة حركة",
    "editTitle": "تعديل الحركة",
    "description": "{{name}} ({{number}})",
    "fields": {
      "kind": "نوع الحركة",
      "amount": "المبلغ",
      "occurredAt": "تاريخ المعاملة",
      "statement": "البيان",
      "notes": "ملاحظات",
      "account": "الحساب"
    },
    "currentBalance": "الرصيد الحالي",
    "balanceAfter": "الرصيد بعد الحركة",
    "laterMovements": "سيعاد احتساب رصيد {{count}} حركة لاحقة",
    "toasts": {
      "created": "تمت إضافة الحركة بنجاح",
      "updated": "تم تحديث الحركة بنجاح"
    }
  },
  "reports": {
    "title": "التقارير",
    "tabs": {
      "statement": "كشف العميل",
      "periodMovements": "حركات الفترة",
      "customerBalances": "أرصدة العملاء"
    },
    "statementPicker": {
      "customer": "العميل",
      "open": "عرض",
      "account": "الحساب"
    },
    "branchTotals": "الفرع"
  },
  "trash": {
    "title": "سلة المحذوفات",
    "type": "النوع",
    "types": {
      "MOVEMENTS": "الحركات",
      "ACCOUNTS": "الحسابات"
    },
    "restore": "استعادة",
    "rowActionsTrigger": "إجراءات السجل {{number}}",
    "restoreDialog": {
      "title": "استعادة السجل؟",
      "movement": "سيتم استعادة الحركة رقم {{number}} وإعادة احتساب رصيد الحركات اللاحقة.",
      "account": "سيتم استعادة الحساب {{account}} رقم {{number}} للعميل {{customer}} مع حركاته."
    },
    "toasts": {
      "restored": "تم استعادة السجل بنجاح"
    }
  },
  "linkError": {
    "PHONE_REJECTED": "رفض نظام العملاء هذا الرقم، عدّل رقم الهاتف",
    "VERIFICATION_EXPIRED": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
    "reverify": "إعادة التحقق"
  },
  "profile": {
    "bannerTitle": "بيانات العميل غير مكتملة",
    "bannerText": "حركات المدين والدائن على حسابات هذا العميل متوقفة حتى تستكمل بياناته.",
    "issues": {
      "NAME_MISSING": "اسم العميل مطلوب",
      "NAME_INVALID": "اسم العميل غير صالح",
      "PHONE_MISSING": "رقم الهاتف مطلوب",
      "PHONE_INVALID": "رقم الهاتف غير صالح"
    },
    "complete": "استكمال البيانات",
    "dialogTitle": "استكمال بيانات العميل",
    "dialogDescription": "أدخل اسم العميل ورقم هاتف خلوي صالح لإضافة الحركات على حساباته.",
    "nameLetters": "يجب أن يحتوي الاسم على حروف عربية أو إنجليزية",
    "completed": "تم استكمال بيانات العميل بنجاح",
    "mergeTitle": "نقل الحسابات إلى العميل المسجل",
    "mergeDescription": "رقم الهاتف {{phone}} مسجل للعميل {{name}}. تنقل حسابات هذا العميل إلى {{name}} كحسابات منفصلة. يبقى لكل حساب رصيده وحركاته وكشفه.",
    "registeredCustomer": "العميل المسجل",
    "accountNamesTitle": "أسماء الحسابات لدى العميل {{name}}",
    "accountNamesHelp": "يجب أن يختلف كل اسم عن حسابات العميل {{name}} في الفرع نفسه.",
    "accountLabel": "اسم الحساب رقم {{number}}",
    "move": "نقل الحسابات",
    "changeNumber": "تغيير الرقم",
    "moved": "تم نقل الحسابات إلى العميل {{name}} بنجاح"
  }
}
